import React from 'react'
import { getValueElement } from '../../TableCompare/utils'
import CardKeyValue from '../../../../../card/cardKeyValue'

const BasicInformationEvidenceOfLearning = ({ detail }) => {
  return (
    <div className='flex flex-col gap-2'>
      { detail.lc &&
        <CardKeyValue 
          title='Learning Continua'
          value={getValueElement(detail?.lc?.lcElements, 'lcElements')} 
        /> 
      }
      {
        detail?.level &&
        <CardKeyValue 
          title='Level'
          value={detail?.level?.name || ''}
        />
      }
    </div>
  )
}

export default BasicInformationEvidenceOfLearning